import gql from 'graphql-tag'


export default gql`
query getCategoryProducts($id: ID!) {
	cashAssist {
		getCategory(id: $id) {
			id
			mod_ver
			gridProducts {
				productId
				product {
					id
					name
					code
				}
			}
		}
	}
}`
